import Spacer from "../../../ui-components/spacer/spacer";

const RaindropLegalTermsAndConditions = () => {
  return (
    <div className={"flex flex-col   px-2 h-screen overflow-visible"}>
      <div>Terms and conditions.</div>
      <Spacer />
    </div>
  );
};

export default RaindropLegalTermsAndConditions;
